//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 10/12/2024
// Version : 1
// Description : pantalla para editar el check siempre y cuando no este revisado (rc.revisado=1)
//------Changes --------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  Paper,
  TableRow,
  TableCell
} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Divider from "@mui/material/Divider";
//ADJUNTAR
import AttachFileIcon from "@mui/icons-material/AttachFile"; //ADJUNTAR IMAGEN
import FileUploadCheck from "./FileUploadCheck";
import { v4 as uuidv4 } from "uuid"; //ADJUNTAR IMAGEN
import moment from "moment";
import DialogConfirmacion from "./DialogConfirmacion";

function EditarCheck(props) {
  const {
    responsable,
    sucursal,
    fecha,
    mostrarResultadoCheck,
    tabla,
    estados,
    datosCheck,
    setDatosCheck,
    setChoferAcompanante,
  } = props;

  // console.log("DATOS CHECK EDITAR", datosCheck);
  const fechaFormat = moment(fecha).format("YYYY-MM");
  const [resultadosCheck, setResultadosCheck] = useState();
  const [selectedDate, setSelectedDate] = useState("");
  const [depositoSeleccionado, setDepositoSeleccionado] = useState("");
  const [uuid, setUuid] = useState(uuidv4()); //ADJUNTAR IMAGEN
  const [openCloseAdj, setOpenCloseAdj] = useState(false); //ADJUNTAR IMAGEN
  const [checkboxStates, setCheckboxStates] = useState({});
  const [observaciones, setObservaciones] = useState({});
  const [fechaResultadoCheck, setFechaResultadoCheck] = useState({});
  const [diasHabiles, setDiasHabiles] = useState({});
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
  const [finalizar, setFinalizar] = useState(); //finalizar === 1 lo manda como prop el componente "notify" e indica que la transaccion ha finalizado y debe ejecutarse la funcion para cerrar
  const [severityAlerta, setSeverityAlerta] = useState(""); //define severidad de la alerta (success error o warning)
  const [severitySnack, setSeveritySnack] = useState(""); //define severidad del snackbar (notificación)
  const [update, setUpdate] = useState(false);
  const [dialogConfirmacion, setDialogConfirmacion] = useState(false);
  // const [checklistCompleto, setChecklistCompleto] = useState(false);

  // -------- fecha -----------//
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };
  const formattedDate = `${selectedDate}`;
  // ----------------------------- GET ---------------------- //
  const [gruposEItems, setGruposEItems] = useState([]);
  const [terminado, setTerminado] = useState(false);

  const obtenerGruposEItems = () => {
    fetch(UrlApi + "/checklist_rrhh_grupos/activos")
      .then((response) => response.json())
      .then((grupos) => {
        const promises = grupos.map((grupo) => {
          // Retorna una promesa para cada llamada a la API
          return fetch(
            UrlApi +
              `/checklist_rrhh_grupos/itemxgrupoActivos/${grupo.id_grupo}`
          )
            .then((response) => response.json())
            .then((items) => ({ grupo, items }));
        });
        // Espera a que todas las promesas se resuelvan
        return Promise.all(promises);
      })
      .then((gruposItemsArray) => {
        // Una vez que todas las llamadas a la API se completen con éxito,
        // actualiza el estado con el array completo de grupos e items
        setGruposEItems(gruposItemsArray);
        setTerminado(true);
      })
      .catch((error) =>
        console.error("Error al obtener grupos e items:", error)
      );
  };

  useEffect(() => {
    obtenerGruposEItems();
  }, []);

  const obtenerResultadosCheck = () => {
    fetch(
      UrlApi +
        "/checklist/verResultadoCheck/" +
        fechaFormat +
        "/" +
        localStorage.getItem("user") +
        "/" +
        fechaFormat +
        "/" +
        sucursal.id
    )
      .then((data) => data.json())
      .then((data) => {
        // --------------------- CHECKBOX------------------------------ //
        // Crear un nuevo objeto para almacenar los estados de los checkboxes actualizados
        const newCheckboxStates = { ...checkboxStates }; // Copiar el estado actual de los checkboxes
        // Iterar sobre los resultados obtenidos
        data.forEach((resultado) => {
          // Comprobar si el grupo ya existe en el estado de los checkboxes
          if (!newCheckboxStates[resultado.id_grupo]) {
            newCheckboxStates[resultado.id_grupo] = {};
          }
          // Actualizar el estado de los checkboxes para este grupo y item
          if (resultado.cumple === 1) {
            newCheckboxStates[resultado.id_grupo][resultado.id_item] = "cumple";
          } else if (resultado.no_cumple === 1) {
            newCheckboxStates[resultado.id_grupo][resultado.id_item] =
              "no_cumple";
          } else {
            newCheckboxStates[resultado.id_grupo][resultado.id_item] = "n_a";
          }
        });
        // Actualizar el estado checkboxStates con los nuevos valores obtenidos
        setCheckboxStates(newCheckboxStates);
        // También puedes hacer otras cosas con los resultados si es necesario
        setResultadosCheck(data);
        // -------------------- OBSERVACIONES ---------------------- //
        // Crear un nuevo objeto para almacenar las observaciones de cada ítem
        const newObservaciones = { ...observaciones };

        // console.log("NEW OBSERVACIONES: ", newObservaciones);
        // Iterar sobre los resultados obtenidos
        data.forEach((resultado) => {
          // Actualizar las observaciones para este ítem
          newObservaciones[resultado.id_item] = resultado.observacion || ""; // Asumiendo que la propiedad en los resultados es 'observacion'
        });
        // Actualizar el estado 'observaciones' con los nuevos valores obtenidos
        setObservaciones(newObservaciones);
        // También puedes hacer otras cosas con los resultados si es necesario
        setResultadosCheck(data);
        // -------------------- FECHA ---------------------- //
        // Extraer la fecha de los resultados si está presente en la respuesta de la API
        const fecha = data.length > 0 ? data[0].fecha : null;
        // Guardar la fecha en el estado
        setFechaResultadoCheck(fecha);
        // -------------------- UUID  ---------------------- //
        // Extraer el UUID si está presente en la respuesta de la API
        const uuid = data.length > 0 ? data[0].uuid : null;
        // Guardar el UUID en el estado
        setUuid(uuid);
        // -------------------- DIAS HABILES  ---------------------- //
        const diasHabiles = data.length > 0 ? data[0].dias_habiles : null;
        setDiasHabiles(diasHabiles);
      });
  };

  useEffect(() => {
    obtenerResultadosCheck();
  }, []);

  //console.log("OBTENER RESULTADOS CHECK DE VER", resultadosCheck);
  const [datosFlota, setDatosFlota] = useState();

  const obtenerResultadosFlota = () => {
    fetch(
      UrlApi +
        "/checklist_chofer_flota/verResultadoFlota/" +
        localStorage.getItem("user") +
        "/" +
        fechaFormat +
        "/" +
        sucursal.id
    )
      .then((res) => res.json())
      .then((datosExistentes) => {
        fetch(UrlApi + "/vehiculos/paraChecklist/" + sucursal.id) // endpoint que trae todos los vehículos activos de la sucursal
          .then((res) => res.json())
          .then((vehiculos) => {
            const datosCompletos = vehiculos.map((veh) => {
              const existente = datosExistentes.find(
                (d) => d.dominio_tipo === veh.id
              );
              return {
                id_flota: existente?.id_flota || null,
                fecha: existente?.fecha || fecha,
                deposito: existente?.deposito || sucursal.id,
                responsable: existente?.responsable || null,
                dominio_tipo: veh.id,
                patente: veh.patente,
                id_modelo: veh.id_modelo,
                modelo: veh.modelo,
                id_marca: veh.id_marca,
                marca: veh.marca,
                dias_inactivos: existente?.dias_inactivos || "",
                kg_vendidos: existente?.kg_vendidos || "",
                km_recorridos: existente?.km_recorridos || "",
                litros_combustible: existente?.litros_combustible || "",
                zona: existente?.zona || "",
                chofer_acompañante: existente?.chofer_acompañante || "",
                usuario: existente?.usuario || localStorage.getItem("user"),
              };
            });
            setDatosFlota(datosCompletos);
            //  console.log("DATOS COMPLETOS", datosCompletos);
          });
      });
  };

  //  console.log("DATOS FLOTA", datosFlota);
  useEffect(() => {
    obtenerResultadosFlota();
  }, []);

  //console.log("RESULTADOS FLOTA", datosFlota);
  const [deposito, setDeposito] = useState();

  const obtenerDepositos = () => {
    fetch(UrlApi + "/sucursales")
      .then((data) => data.json())
      .then((data) => setDeposito(data));
  };
  useEffect(() => {
    obtenerDepositos();
  }, []);

  // console.log("DEPOSITOS", depositoSeleccionado);
  const [comercial, setComercial] = useState();

  const obtenerComercial = () => {
    fetch(UrlApi + "/representantes/activos/")
      .then((data) => data.json())
      .then((data) => setComercial(data));
  };
  useEffect(() => {
    obtenerComercial();
  }, []);

  const [representante, setRepresentante] = useState();

  const obtenerRepresentante = () => {
    fetch(UrlApi + "/representantes/getid/" + localStorage.getItem("user"))
      .then((data) => data.json())
      .then((data) => setRepresentante(data));
  };
  useEffect(() => {
    obtenerRepresentante();
  }, []);

  // ------------------ESTILO -------------------- //
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const size = "small";
  //------------------- ADJUNTO ----------------------- //
  const handleOpenCloseAdj = (value) => {
    setOpenCloseAdj(value);
  };
  //-------- Función para contar la cantidad de checks marcados ------------- //
  const contarChecksMarcados = () => {
    let cantidadCumple = 0;
    let cantidadNoCumple = 0;
    let cantidadNA = 0;

    // Iterar sobre los grupos
    for (const grupoId in checkboxStates) {
      // Iterar sobre los items dentro del grupo
      for (const itemId in checkboxStates[grupoId]) {
        const estado = checkboxStates[grupoId][itemId];
        // Contar los estados de los checkboxes
        if (estado === "cumple") {
          cantidadCumple++;
        } else if (estado === "no_cumple") {
          cantidadNoCumple++;
        } else if (estado === "n_a") {
          cantidadNA++;
        }
      }
    }

    return {
      cumple: cantidadCumple,
      no_cumple: cantidadNoCumple,
      n_a: cantidadNA,
    };
  };
  // Llamada a la función para obtener la cantidad de checks marcados
  const cantidadChecks = contarChecksMarcados(checkboxStates);
  // console.log("cantidad check",contarChecksMarcados(checkboxStates));

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const calcularTotalKgVendidos = () => {
    return (Array.isArray(datosFlota) ? datosFlota : []).reduce(
      (total, linea) => total + Number(linea.kg_vendidos || 0),
      0
    );
  };
  /*------------------------ CHECKBOX --------------------------------- */
  // Función para manejar cambios en los checkboxes
  const handleChange = (grupoId, itemId, checked) => {
    setCheckboxStates((prevState) => ({
      ...prevState,
      [grupoId]: {
        ...prevState[grupoId],
        [itemId]: checked ? checked : null,
      },
    }));
  };
  /* ----------------------- OBSERVACIONES ------------------------------ */
  // Función para actualizar la observación de un elemento específico
  const actualizarObservacion = (itemId, value) => {
    setObservaciones((prev) => ({
      ...prev,
      [itemId]: value,
    }));
  };

  const almacenar = (e) => {
    setDatosCheck({
      ...datosCheck,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };

  const almacenar2 = (event) => {
    const { name, value } = event.target;
    setDiasHabiles(value); // Actualizar estado con el nuevo valor
  };

  //---------------- HANDLE para los cambios en editar -------------//
  const handleDiasInactivoChange = (index, dias_inactivos) => {
    setDatosFlota((prevLineas) =>
      prevLineas.map((linea, i) =>
        i === index ? { ...linea, dias_inactivos } : linea
      )
    );
  };

  const handleKgVendidosChange = (index, kg_vendidos) => {
    setDatosFlota((prevLineas) =>
      prevLineas.map((linea, i) =>
        i === index ? { ...linea, kg_vendidos } : linea
      )
    );
  };

  const handleKmRecorridosChange = (index, km_recorridos) => {
    setDatosFlota((prevLineas) =>
      prevLineas.map((linea, i) =>
        i === index ? { ...linea, km_recorridos } : linea
      )
    );
  };

  const handleLitrosCombuChange = (index, litros_combustible) => {
    setDatosFlota((prevLineas) =>
      prevLineas.map((linea, i) =>
        i === index ? { ...linea, litros_combustible } : linea
      )
    );
  };

  const handleZonaChange = (index, zona) => {
    setDatosFlota((prevLineas) =>
      prevLineas.map((linea, i) => (i === index ? { ...linea, zona } : linea))
    );
  };

  const handleChoferChange = (index, chofer_acompañante) => {
    setChoferAcompanante(chofer_acompañante);
    setDatosFlota((prevLineas) =>
      prevLineas.map((linea, i) =>
        i === index ? { ...linea, chofer_acompañante } : linea
      )
    );
  };

  // ********** AGREGADO PARA GUARDAR EN ESTADO EVALUACION ************* //
  const [subitemEvaluacion, setSubitemEvaluacion] = useState(null);

  const obtenerSubitems = () => {
    fetch(UrlApi + "/subitems_comerciales/xiditem/" + 5)
      .then((data) => data.json())
      .then((data) => setSubitemEvaluacion(data));
  };

  useEffect(() => {
    obtenerSubitems();
  }, []);
  const porcentajeChecklist =
    subitemEvaluacion && subitemEvaluacion[0]
      ? subitemEvaluacion[0].porcentaje
      : null;

  const handleOpenDialog = () => {
    setDialogConfirmacion(true);
  };

  const handleCloseDialog = () => {
    setDialogConfirmacion(false);
  };

  return (
    <div>
      <Box
        bgcolor="#2B76A6"
        padding={1}
        color="white"
        textAlign="center"
        display="flex" // Agregado para que los elementos se coloquen en línea
        alignItems="center"
        marginTop={1}
        flexWrap="wrap"
        gap={1}
      >
        <AssignmentIcon sx={{ fontSize: { xs: 28, md: 40 } }} />
        <Typography fontSize={{ xs: 24, sm: 22, md: 28 }}>
          Editar control
        </Typography>
      </Box>
      <br></br>
      {resultadosCheck &&
      resultadosCheck.length > 0 &&
      resultadosCheck[0].revisado !== 1 &&
      estados[0].auditado !== 1 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            width: "100%",
          }}
        >
          <Paper
            elevation={6}
            sx={{
              width: { xs: "90%", sm: "100%", md: "100%" }, //  más flexible
              maxWidth: "1100px", // límite en pantallas grandes
              mx: "auto", //  centrado
              p: { xs: 1, md: 4 },
              borderRadius: 2,
            }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={6}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  alignItems: "start",
                  textAlign: "start",
                }}
              >
                <Typography variant="h4" fontSize={{ xs: 20, md: 20 }}>
                  <b>Responsable:</b>&nbsp;{responsable}
                  <br></br>
                  <b>Sucursal:</b>&nbsp; {sucursal.nombre}
                  <br></br>
                </Typography>
              </Grid>
              {estados[0].auditado === 1 ? (
                <Grid
                  item
                  xs={12}
                  md={6}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    alignItems: "start",
                    textAlign: "start",
                  }}
                >
                  <Typography variant="poster" fontSize={{ xs: 20, md: 20 }}>
                    <b>Auditor:</b>&nbsp; {estados[0].auditor}
                    <br></br>
                    <b>Fecha de auditoría:</b>&nbsp;
                    {moment(estados[0].fecha_auditado).format("DD-MM-YYYY")}
                  </Typography>
                </Grid>
              ) : null}
            </Grid>
            <Table>
              <TableBody>
                {/* Mapea sobre gruposEItems para renderizar cada grupo y sus items */}
                {terminado === true &&
                  gruposEItems.map((grupoItem) => (
                    <TableRow key={grupoItem.grupo.id_grupo}>
                      <TableCell
                        colSpan={3}
                        style={{ padding: 0, border: "none" }}
                      >
                        {/* Título del Grupo */}
                        <Grid container>
                          <Grid item xs={12} sm={12}>
                            <Typography
                              className="titulo-grupo"
                              style={{
                                fontSize: "16px",
                                backgroundColor: "#C7C7C7",
                                padding: 8,
                              }}
                            >
                              <b>{grupoItem.grupo.nombre_grupo}</b>
                            </Typography>
                          </Grid>

                          {/* Items del Grupo */}
                          <Grid item xs={12} sm={12} mt={1}>
                            {grupoItem.items.map((item, index) => (
                              <Grid
                                container
                                key={item.id_item}
                                spacing={2}
                                alignItems="center"
                              >
                                {/* Nombre y Definición del Item */}
                                <Grid item xs={12} sm={4}>
                                  <b
                                    className="nombre-item"
                                    style={{ fontSize: "18px" }}
                                  >
                                    {item.nombre_item}
                                  </b>
                                  <br />
                                  <span
                                    className="definicion-item"
                                    style={{ fontSize: "16px" }}
                                  >
                                    {item.definicion_item}
                                  </span>
                                </Grid>

                                <Grid item xs={2} sm={3}>
                                  <FormGroup aria-label="position">
                                    <Grid container direction="column">
                                      <Grid item>
                                        <FormControlLabel
                                          disabled={
                                            datosCheck.no_cumple === 1 ||
                                            datosCheck.n_a === 1
                                          }
                                          labelPlacement="end"
                                          label="Cumple"
                                          control={
                                            <Checkbox
                                              name="cumple"
                                              checked={
                                                checkboxStates[
                                                  grupoItem.grupo.id_grupo
                                                ]?.[item.id_item] ===
                                                  "cumple" || false
                                              }
                                              onChange={(e) =>
                                                handleChange(
                                                  grupoItem.grupo.id_grupo,
                                                  item.id_item,
                                                  e.target.checked
                                                    ? "cumple"
                                                    : null
                                                )
                                              }
                                            />
                                          }
                                        />
                                      </Grid>

                                      <Grid item>
                                        <FormControlLabel
                                          disabled={
                                            datosCheck.cumple === 1 ||
                                            datosCheck.n_a === 1
                                          }
                                          labelPlacement="end"
                                          label="No cumple"
                                          control={
                                            <Checkbox
                                              name="no_cumple"
                                              checked={
                                                checkboxStates[
                                                  grupoItem.grupo.id_grupo
                                                ]?.[item.id_item] ===
                                                  "no_cumple" || false
                                              }
                                              onChange={(e) =>
                                                handleChange(
                                                  grupoItem.grupo.id_grupo,
                                                  item.id_item,
                                                  e.target.checked
                                                    ? "no_cumple"
                                                    : null
                                                )
                                              }
                                            />
                                          }
                                        />
                                      </Grid>
                                      <Grid item>
                                        <FormControlLabel
                                          disabled={
                                            datosCheck.cumple === 1 ||
                                            datosCheck.no_cumple === 1
                                          }
                                          labelPlacement="end"
                                          label="N/A"
                                          control={
                                            <Checkbox
                                              name="n_a"
                                              checked={
                                                checkboxStates[
                                                  grupoItem.grupo.id_grupo
                                                ]?.[item.id_item] === "n_a" ||
                                                false
                                              }
                                              onChange={(e) =>
                                                handleChange(
                                                  grupoItem.grupo.id_grupo,
                                                  item.id_item,
                                                  e.target.checked
                                                    ? "n_a"
                                                    : null
                                                )
                                              }
                                            />
                                          }
                                        />
                                      </Grid>
                                    </Grid>
                                  </FormGroup>
                                </Grid>

                                <Grid item xs={12} sm={5}>
                                  <TextField
                                    required={
                                      checkboxStates[
                                        grupoItem.grupo.id_grupo
                                      ]?.[item.id_item] === "no_cumple" ||
                                      item.obs_oblig === 1
                                        ? true
                                        : false
                                    }
                                    fullWidth
                                    size={size}
                                    margin="normal"
                                    placeholder={
                                      checkboxStates[
                                        grupoItem.grupo.id_grupo
                                      ]?.[item.id_item] === "no_cumple" ||
                                      item.obs_oblig === 1
                                        ? "Por favor, ingrese una observación"
                                        : ""
                                    }
                                    style={{
                                      ...style,
                                      width: "100%",
                                    }}
                                    focused
                                    color="primary"
                                    name="observacion"
                                    label="Observaciones"
                                    variant="outlined"
                                    multiline
                                    rows={6}
                                    value={observaciones[item.id_item]} // Usar la observación correspondiente
                                    inputProps={{
                                      maxLength: 200,
                                    }}
                                    onChange={(e) =>
                                      actualizarObservacion(
                                        item.id_item,
                                        e.target.value
                                      )
                                    }
                                  />
                                </Grid>
                                {index !== grupoItem.items.length - 1 && ( // Asegura que el divider se renderice solo si el item NO es el último de los mapeados
                                  <Divider
                                    style={{
                                      width: "90%",
                                      marginTop: 8,
                                      marginBottom: 8,
                                      marginLeft: "auto",
                                      marginRight: "auto",
                                    }}
                                  />
                                )}
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <Divider
              style={{
                width: "100%",
                marginTop: 8,
                marginBottom: 8,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            />

            <div style={{ textAlign: "center", marginTop: 20 }}>
              <Typography
                variant="poster"
                fontSize={19}
                style={{ textDecoration: "underline", marginTop: 20 }}
              >
                <b>Resultados : </b>
              </Typography>
              <br />
              <br />
              <Typography variant="poster" fontSize={19}>
                Cumplidos : {cantidadChecks.cumple} - No cumplidos :{" "}
                {cantidadChecks.no_cumple}
              </Typography>
              <Box mt={3}>
                <Button
                  onClick={() => setOpenCloseAdj(!openCloseAdj)}
                  variant="outlined"
                  size="medium"
                  startIcon={<AttachFileIcon />}
                >
                  VER ARCHIVOS ADJUNTOS
                </Button>
              </Box>
            </div>

            <br></br>
            <Divider style={{ width: "100%", marginTop: 20 }} />
            <br></br>

            <div
              style={{
                textAlign: "left",
                textDecoration: "underline",
              }}
            >
              <Typography
                fontSize={{ xs: 21, md: 24 }}
                sx={{ textDecoration: "underline", mb: 2 }}
              >
                <b>Flota de vehículos:</b>
              </Typography>
            </div>

            <Typography
              align="center"
              fontSize={{ xs: 14, md: 20 }}
              mt={1}
              mb={2}
            >
              *Ante faltante de vehículos comuníquese con RR.HH.
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={7} sm={3} mb={3}>
                <TextField
                  label="Días habiles en el periodo"
                  name="dias_habiles"
                  size="small"
                  focused
                  required
                  fullWidth
                  autoComplete="off"
                  inputProps={{
                    max: 31,
                  }}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault(); // Permitir solo números
                    }
                  }}
                  value={diasHabiles}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (
                      value === "" || // Permitir borrar el valor
                      (Number(value) <= 31 && Number(value) >= 0) // Validar rango permitido
                    ) {
                      almacenar2(event); // Actualizar estado con el nuevo valor
                    }
                  }}
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                padding: 2,
                backgroundColor: "#f5f5f5",
              }}
            >
              {datosFlota &&
                datosFlota.map((linea, index) => (
                  <Box
                    key={linea.id_flota}
                    sx={{
                      padding: { xs: 2, md: 3 },
                      marginBottom: 2,
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={5} md={5} lg={5}>
                        <TextField
                          label="Dominio y Tipo"
                          size="small"
                          focused
                          fullWidth
                          inputProps={{
                            readOnly: true, // Establecer el campo como de solo lectura
                          }}
                          value={`${linea.patente} - ${linea.marca} - ${linea.modelo}`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={1.5} md={1.5} lg={1.5}>
                        <TextField
                          label="Días Inactivos"
                          name="dias_inactivos"
                          size="small"
                          focused
                          required
                          fullWidth
                          autoComplete="off"
                          inputProps={{
                            readOnly: false, // Cambiar a `true` si deseas hacerlo solo lectura en ciertos casos
                          }}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault(); // Permitir solo números
                            }
                          }}
                          value={linea.dias_inactivos || ""} // Asegúrate de inicializar con un valor válido
                          onChange={(e) =>
                            handleDiasInactivoChange(index, e.target.value)
                          } // Manejar cambios
                        />
                      </Grid>
                      <Grid item xs={12} sm={1.5} md={1.5} lg={1.5}>
                        <TextField
                          label="Kg.Vendidos"
                          name="kg_vendidos"
                          size="small"
                          focused
                          required
                          fullWidth
                          autoComplete="off"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          value={linea.kg_vendidos || ""}
                          onChange={(e) =>
                            handleKgVendidosChange(index, e.target.value)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={2} md={2} lg={2}>
                        <TextField
                          label="Km.Recorridos"
                          name="km_recorridos"
                          size="small"
                          focused
                          required
                          fullWidth
                          autoComplete="off"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          value={linea.km_recorridos || ""}
                          onChange={(e) =>
                            handleKmRecorridosChange(index, e.target.value)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={2} md={2} lg={2}>
                        <TextField
                          label="Lts.Combustible"
                          name="litros_combustible"
                          size="small"
                          focused
                          required
                          fullWidth
                          autoComplete="off"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          value={linea.litros_combustible || ""}
                          onChange={(e) =>
                            handleLitrosCombuChange(index, e.target.value)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={5} md={5} lg={5}>
                        <TextField
                          label="Zona de Reparto"
                          name="zona"
                          size="small"
                          focused
                          required
                          fullWidth
                          autoComplete="off"
                          value={linea.zona}
                          onChange={(e) =>
                            handleZonaChange(index, e.target.value)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <TextField
                          label="Chofer y Acompañante"
                          name="chofer_acompañante"
                          size="small"
                          focused
                          required
                          fullWidth
                          autoComplete="off"
                          value={linea.chofer_acompañante}
                          onChange={(e) =>
                            handleChoferChange(index, e.target.value)
                          }
                        />
                      </Grid>
                    </Grid>
                  </Box>
                ))}
            </Box>
            <Grid container justifyContent="center" alignItems="center">
              <Typography
                fontWeight="bold"
                sx={{ fontSize: { xs: 16, md: 19 } }}
                mt={1}
              >
                Total Kg. Vendidos: {calcularTotalKgVendidos()}
              </Typography>
            </Grid>
            <br></br>
            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-end"
              mt={2}
            >
              <Button variant="contained" onClick={handleClose} color="error">
                Volver sin editar
              </Button>
              <Button
                variant="contained"
                onClick={handleOpenDialog}
                color="success"
              >
                Guardar edición
              </Button>
            </Grid>
            <br></br>
          </Paper>
        </div>
      ) : (
        <Paper
          elevation={6}
          sx={{
            mt: 2,
            mx: "auto",
            width: { xs: "80%", md: "90%" },
            p: 2,
          }}
        >
          <Typography variant="body1" color="textSecondary" align="center">
            <strong>No esta disponible para editar</strong>
          </Typography>
        </Paper>
      )}

      {openCloseAdj ? ( // ADJUNTAR IMAGEN
        <FileUploadCheck
          fileId={uuid}
          openclose={true}
          mostrar={true}
          onClose={() => handleOpenCloseAdj(false)} // Proporciona una función de cierre
        />
      ) : null}

      {dialogConfirmacion ? (
        <DialogConfirmacion
          open={dialogConfirmacion}
          onClose={handleCloseDialog}
          onVolver={handleClose}
          fecha={datosCheck.fecha}
          estados={estados}
          checkboxStates={checkboxStates}
          observaciones={observaciones}
          gruposEItems={gruposEItems}
          resultadosCheck={resultadosCheck}
          depositoSeleccionado={depositoSeleccionado}
          representante={representante}
          diasHabiles={diasHabiles}
          uuid={uuid}
          datosFlota={datosFlota}
          contarChecksMarcados={contarChecksMarcados}
          setDatosFlota={setDatosFlota}
        />
      ) : null}
      <br></br>
      <br></br>
    </div>
  );
}

export default EditarCheck;
